import { Button, Divider, Stack, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { AssignDisciplineNames } from '../../models/Review'
import {
  ElectricalEngineeringIcon,
  MechanicalEngineeringIcon,
  StructuralEngineeringIcon,
} from '../Svgs'
import { getCategoryColor } from '../../utils/ComponentsUtil'

interface EngineerDetailedInfoProps {
  engineer: {
    name: string
    location: string
    phoneNumber: string
    email: string
    projects: string[]
  }
}

const EngineerDetailedInfoComponent: React.FC<EngineerDetailedInfoProps> = ({
  engineer,
}) => {
  const specialties = [
    AssignDisciplineNames.Mechanical,
    AssignDisciplineNames.Electrical,
    AssignDisciplineNames.Structural,
  ]

  const getCategoryIcon = (category: AssignDisciplineNames) => {
    switch (category) {
      case AssignDisciplineNames.Mechanical:
        return (
          <MechanicalEngineeringIcon
            color={getCategoryColor(AssignDisciplineNames.Mechanical)}
          />
        )
      case AssignDisciplineNames.Electrical:
        return (
          <ElectricalEngineeringIcon
            color={getCategoryColor(AssignDisciplineNames.Electrical)}
          />
        )
      case AssignDisciplineNames.Structural:
        return (
          <StructuralEngineeringIcon
            color={getCategoryColor(AssignDisciplineNames.Structural)}
          />
        )
    }
  }

  const detailedInfo = [
    {
      name: 'Email',
      value: engineer.email,
    },
    {
      name: 'Phone Number',
      value: engineer.phoneNumber,
    },
    {
      name: 'Structural',
      value: engineer.phoneNumber,
    },
  ]

  return (
    <>
      <Divider flexItem />
      <Box
        gap={'1.5rem'}
        sx={{
          display: 'flex',
          width: '100%',
          boxSizing: 'border-box',
          pl: '3rem',
          mt: '0.75rem',
        }}
      >
        <Box
          gap={'0.5rem'}
          sx={{ display: 'flex', flexDirection: 'column', width: '28%' }}
        >
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
            }}
          >
            <Typography
              sx={{
                color: '#797979',
                fontSize: '0.7rem',
                fontWeight: 500,
                lineHeight: 'normal',
              }}
            >
              Current Projects
            </Typography>
            <Box
              sx={{
                width: '1rem',
                height: '1rem',
                background: '#EFEFEF',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography
                sx={{
                  color: '#797979',
                  fontSize: '0.7rem',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}
              >
                {engineer.projects.length}
              </Typography>
            </Box>
          </Box>
          <Stack
            sx={{
              borderRadius: '6px',
              boxShadow: '0px 3px 5px 0px #2F2F2F1A',
              px: '0.75rem',
              height: '9.25rem',
              overflowY: 'auto',
            }}
          >
            {engineer.projects.map((projectName, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #E4E4E4',
                  py: '0.4rem',
                }}
              >
                <Box
                  gap='0.75rem'
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  <Box
                    sx={{
                      borderRadius: '50%',
                      width: '0.5rem',
                      height: '0.5rem',
                      background: '#1705E5',
                    }}
                  />
                  <Typography
                    sx={{
                      color: '#04002E',
                      fontSize: '0.76rem',
                      fontWeight: 500,
                      lineHeight: 'normal',
                    }}
                  >
                    {projectName}
                  </Typography>
                </Box>
                <Button
                  variant='outlined'
                  sx={{
                    textTransform: 'capitalize',
                    fontSize: '0.64rem',
                    borderRadius: '4px',
                    background: 'transparent',
                    border: '1px solid #56003D',
                    color: '#56003D',
                    height: '1.5rem',
                  }}
                >
                  See File
                </Button>
              </Box>
            ))}
          </Stack>
        </Box>
        <Box
          gap={'0.5rem'}
          sx={{ display: 'flex', flexDirection: 'column', width: '28%' }}
        >
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
            }}
          >
            <Typography
              sx={{
                color: '#797979',
                fontSize: '0.7rem',
                fontWeight: 500,
                lineHeight: 'normal',
              }}
            >
              Assigned Specialties
            </Typography>
          </Box>
          <Stack
            sx={{
              borderRadius: '6px',
              boxShadow: '0px 3px 5px 0px #2F2F2F1A',
              px: '0.75rem',
              height: '9.25rem',
              overflowY: 'hidden',
            }}
          >
            {specialties.map((speciality, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'space-between',
                  borderBottom: '1px solid #E4E4E4',
                  py: '0.8rem',
                }}
              >
                <Box
                  gap='0.75rem'
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  {getCategoryIcon(speciality)}
                  <Typography
                    sx={{
                      color: '#04002E',
                      fontSize: '0.76rem',
                      fontWeight: 500,
                      lineHeight: 'normal',
                    }}
                  >
                    {speciality}
                  </Typography>
                </Box>
                <Button
                  variant='outlined'
                  sx={{
                    textTransform: 'capitalize',
                    fontSize: '0.64rem',
                    borderRadius: '4px',
                    background: 'transparent',
                    border: '1px solid #56003D',
                    color: '#56003D',
                    height: '1.5rem',
                    width: '6.5rem',
                  }}
                >
                  Not Assigned
                </Button>
              </Box>
            ))}
          </Stack>
        </Box>
        <Box
          gap={'0.5rem'}
          sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}
        >
          <Typography
            sx={{
              color: '#797979',
              fontSize: '0.7rem',
              fontWeight: 500,
              lineHeight: 'normal',
            }}
          >
            Info
          </Typography>
          <Stack
            sx={{
              borderRadius: '6px',
              boxShadow: '0px 3px 5px 0px #2F2F2F1A',
              px: '1.25rem',
              height: '9.25rem',
              overflowY: 'hidden',
            }}
          >
            {detailedInfo.map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  width: '100%',
                  borderBottom: '1px solid #E4E4E4',
                  py: '0.8rem',
                }}
              >
                <Box
                  gap='0.75rem'
                  sx={{ display: 'flex', alignItems: 'center', width: '25%' }}
                >
                  <Typography
                    sx={{
                      color: '#04002E',
                      fontSize: '0.76rem',
                      fontWeight: 500,
                      lineHeight: 'normal',
                    }}
                  >
                    {item.name}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flex: 1,
                    border: '1px solid #E4E4E4',
                    borderRadius: '4px',
                    padding: '0.26rem',
                  }}
                >
                  <Typography
                    sx={{
                      color: '#797979',
                      fontSize: '0.64rem',
                      fontWeight: 500,
                      lineHeight: 'normal',
                    }}
                  >
                    {item.value}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Stack>
        </Box>
      </Box>
    </>
  )
}

export default EngineerDetailedInfoComponent
